export const HOME_PAGE_ROUTE = '/';
export const LOGIN_PAGE_ROUTE = '/login';